import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function BombolonesPage() {

    const heroData = [
        {
          title: "Bombolones",
          content: "Experience the joy of authentic Italian bombolones - light, fluffy, and perfectly fried doughnuts filled with luscious creams, jams, or chocolate. These irresistible treats are a taste of Italy in every bite.",
          image: images.BombolonesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Cinnamon Sugar",
        content: "Classic donut coated in cinnamon sugar",
        price: 0,
        image: [
          images.Bombolone1,
        ]
      },
      {
        name: "Hazelnut Chocolate",
        content: "Filled with smooth hazelnut chocolate spread",
        price: 0,
        image: [
          images.Bombolone2,
        ]
      },
      {
        name: "Pistachio",
        content: "Filled with a pistachio cream",
        price: 0,
        image: [
          images.Bombolone3,
        ]
      },
      {
        name: "Lotus",
        content: "Filled with Lotus biscuit spread",
        price: 0,
        image: [
          images.Bombolone2,
        ]
      },
      {
        name: "White Chocolate",
        content: "Filled with white chocolate ganache",
        price: 0,
        image: [
          images.Bombolone3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Hazelnut Chocolate",
        image1: [
          images.Bombolone2,
        ],
        content1: "Filled with smooth hazelnut chocolate spread",
        name2: "Pistachio",
        image2: [
          images.Bombolone3,
        ],
        content2: "Filled with a pistachio cream"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
